const routes = [
  {
    url: /\/Receiver/,
    method: 'Get',
    reply: function (request) {
      const result = Array.from(
        { length: request.params.take },
        (value, index) => {
          return {
            id: index,
            userId: '14078501-a4fe-4e80-a505-0149b864f8fa',
            isRead: true,
            dateTimeReceived: Date.now(),
            dateTimeRead: Date.now(),
            notificationRule: {
              senderId: 'cc1f2e8f-c8c7-47fc-b495-cdecb54b66e9',
              statusProcess: undefined,
              notification: {
                title: `Notification ${index}`,
                body: 'Let the bodies hit the floor',
                urlTitle: 'Click',
                urlAction: undefined,
                createdOn: Date.now()
              }
            }
          }
        }
      )

      return [200, { result }]
    }
  }
]

export default routes
